import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { GotopButton } from './GotopButton';
import { Logo } from './Logo';

import { __Pages }    from './__Pages';
import   __Page       from './__Page';
import { __Covers }   from './__Covers';
import   __Books      from './__Books';
import   __About      from './__About';
import { __Contact }  from './__Contact';
import { __Home }     from './__Home';

import Menu   from './Menu';

export class Header extends React.Component {
  constructor () {
    super();
    this.state = {
      classBack: 'menu-mob-back menu-mob--close',
      class: 'menu-mob menu-mob--close',
      closed: true
    }
    this.openCloseMenu = this.openCloseMenu.bind(this);
  }

  componentDidUpdate () {
    window.scrollTo(0, 0)

    var refContact = window.location.href.indexOf("Contact");
    if (refContact !== -1) {
      document.getElementById("obvious").classList.remove("come");
    } else {
      setTimeout(() => {
        document.getElementById("obvious").classList.add("come");
      }, 1000)
    }
  }

  openCloseMenu() {
    this.setState( prevState => ({
      closed: !prevState.closed // toggle true/false
    }));
    if (this.state.closed) {
      this.setState({
        classBack: 'menu-mob-back menu-mob--open',
        class: 'menu-mob menu-mob--open'
      });
    } else {
      this.setState( prevState => ({
        classBack: 'menu-mob-back menu-mob--close',
        class: 'menu-mob menu-mob--close'
      }));
    }
  }

  render () {
    return (
      <div>
        <div className={this.state.classBack}></div>
          <Menu menuClass={this.state.class} menuItemClass="menu-mob-item" propOnClick={this.openCloseMenu} homeDisplay="block" closeDisplay="block"/>
        <div id="mob-but" onClick={this.openCloseMenu}>Menu</div>
        <div className="gardin">
          <div className="menu">
            <div id="logooo" className={this.props.logoClass} style={{ display: this.props.logoDisplay}}>
              <Link to='/'><Logo /></Link>
            </div>
            <Menu menuClass="menu-desk" menuItemClass="menu-item" />
          </div>
        </div>
        <Link to='/Contact'><div className="obvious-contact" id="obvious">@</div></Link>
      </div>
    );
  }
}

export const Main = () => (
  <main>
    <Switch>
      <Route exact path='/' component={ __Home }/>
      <Route exact path='/Pages' component={ __Pages }/>
      <Route path='/Pages/:pageName' component={ __Page }/>
      <Route path='/Covers' component={ __Covers }/>
      <Route path='/Books' component={ __Books }/>
      <Route path='/About' component={ __About }/>
      <Route path='/Contact' component={ __Contact }/>
    </Switch>
  </main>
)

export class Footer extends React.Component {
  constructor() {
    super();
    this.state = {
      year: new Date().getFullYear()
    }
  }

  render() {
    return (
      <footer>
        <GotopButton />
        <Menu menuClass="menu-footer" menuItemClass="menu-item" underline="none" homeDisplay="block" />
        <div className="social">
          <a href="https://www.instagram.com/bebiboo_books/"><div className="inst"></div></a>
          <a href="https://www.youtube.com/channel/UCd4IBciUBnvU6rNrufZv7cQ"><div className="yt"></div></a>
          <a href="https://www.facebook.com/groups/524678854371782/?fref=ts"><div className="fb"></div></a>
        </div>
        <p>© 2015-{this.state.year} all rights reserved.</p>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Body.js